import React, { useEffect } from "react";
import QRCode from "qrcode";
import { useAppDispatch } from "../../app/hooks";
import { verifyTotp } from "./loginSlice";
import OtpInput from "react-otp-input-rc-17";
export interface OtpCreationProps {
  totpSecret: string;
  totpUri: string;
}

export const OtpCreation: React.FC<OtpCreationProps> = ({
  totpSecret,
  totpUri,
}) => {
  const [qrDataUrl, setQrDataUrl] = React.useState<string>("");
  const [otpCode, setOtpCode] = React.useState<string>("");
  const dispatch = useAppDispatch();
  useEffect(() => {
    const generateQrCode = async () => {
      try {
        const url = await QRCode.toDataURL(totpUri);
        setQrDataUrl(url);
      } catch (err) {
        console.error("Error generating QR code", err);
      }
    };
    generateQrCode();
  }, [totpUri]);

  const verifyToken = () => {
    dispatch(verifyTotp(otpCode));
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (otpCode.length === 6) {
        verifyToken();
      }
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h2 style={{ marginBottom: "40px" }}>
        Configura tu autenticación de dos factores
      </h2>
      <p>
        Escanea el <strong>código QR</strong> o ingresa manualmente la{" "}
        <strong>llave</strong> en tu aplicación de autenticación (Google
        Authenticator, Authy, etc.).
      </p>
      <p>
        <img
          src={qrDataUrl}
          alt="Código QR para OTP"
          style={{
            border: "1px solid #000000",
            borderRadius: "8px",
          }}
        />
      </p>
      <p>
        <strong>Llave:</strong> {totpSecret}
      </p>
      <p>
        Esta llave es <strong>personal</strong> y{" "}
        <strong>confidencial</strong>. No la compartas con terceros bajo ninguna
        circunstancia.
      </p>
      <p>Guárdala únicamente en tu aplicación de autenticación</p>
      <p>
        Una vez configurado, introduce el código de 6 dígitos generado para
        activar la configuración.
      </p>
      <div onKeyDown={handleKeyDown}>
        <OtpInput
          inputStyle={{
            background: "#e6e6e6",
            border: "none",
            height: "47px",
            width: "45px",
            borderRadius: "6px",
            marginRight: "7px",
            color: "black",
            fontSize: "25px",
          }}
          containerStyle={{
            marginBottom: "8px",
            marginLeft: "2%",
          }}
          isInputNum={true}
          value={otpCode}
          onChange={setOtpCode}
          numInputs={6}
        />
      </div>
      <button
        className="text-medium text-bold primary-color"
        style={{
          border: "none",
          textAlign: "center",
          borderRadius: "8px",
          background: otpCode.length === 6 ? "#1A617D" : "#A9A9A9",
          paddingTop: "5px",
          paddingBottom: "5px",
          paddingRight: "10%",
          paddingLeft: "10%",
          marginTop: "20px",
        }}
        disabled={otpCode.length < 6}
        onClick={verifyToken}
      >
        Verificar
      </button>
    </div>
  );
};
